import { ResumenDepartamento, Departamento } from '../tipos/vacaciones';
import { API_ENDPOINTS } from '../config/apiConfig';
import { fetchJson } from './api';

/**
 * Obtiene la lista de departamentos (para combos/dropdowns).
 */
export function getAll(): Promise<Departamento[]> {
  return fetchJson<Departamento[]>(API_ENDPOINTS.departamentos);
}

/**
 * Obtiene el resumen de todos los departamentos.
 */
export function getResumen(): Promise<ResumenDepartamento[]> {
  return fetchJson<ResumenDepartamento[]>(
    `${API_ENDPOINTS.departamentos}/resumen`
  );
}
